/**
 * Global Components
 */
import Vue from 'vue'

// import VuePerfectScrollbar from "vue-perfect-scrollbar";
// import AppSectionLoader from "Components/AppSectionLoader/AppSectionLoader";
// import { RotateSquare2 } from "vue-loading-spinner";

// App Card component
import AppCard from 'Components/AppCard/AppCard'
import AppCardCustom from 'Components/AppCard/AppCardCustom'

// App Table component
import AppTable from 'Components/AppTable/AppTable'

// page title bar
import PageTitleBar from 'Components/PageTitleBar/PageTitleBar'

// App Picker component
import AppDatePicker from 'Components/AppPicker/AppDatePicker'
import AppTimePicker from 'Components/AppPicker/AppTimePicker'

// App Dialog component
import AppDialog from 'Components/AppDialog/AppDialog'

import AppSectionLoader from 'Components/AppSectionLoader/AppSectionLoader.vue'

import AppFileUpload from 'Components/FileUpload/file-upload.vue'

import AppHeader from 'Components/AppHeader/AppHeader'

/* eslint-disable @typescript-eslint/no-var-requires */
const VueEditor = require('vue2-editor')

/* eslint-disable @typescript-eslint/no-var-requires */
// const wysiwyg = require('vue-wysiwyg')

Vue.component('appCard', AppCard)
Vue.component('appCardCustom', AppCardCustom)
Vue.component('appTable', AppTable)
Vue.component('appDatePicker', AppDatePicker)
Vue.component('appTimePicker', AppTimePicker)
Vue.component('appDialog', AppDialog)
Vue.component('pageTitleBar', PageTitleBar)
Vue.component('appSectionLoader', AppSectionLoader)
Vue.component('appFileUpload', AppFileUpload)
Vue.component('appHeader', AppHeader)
Vue.component('VueEditor', VueEditor)
// Vue.component('wysiwyg', wysiwyg)
